import * as React from 'react'
import { Container } from 'typescript-ioc'
import { classnames } from '@halo/_utils/classnames'
import { FeedService } from '@halo/services/feed.service'
import { useLoadableDataState } from '@pushly/aqe/lib/hooks/index'
import './feed-page.scss'
import { FeedPageHeader } from '@halo/portals/post-auth/domains/feeds/feed-page-header'
import { FeedDetailsWell } from '@halo/portals/post-auth/domains/feeds/feed-details-well'
import { useState } from 'react'
import { DomainDto } from '@halo/dtos/domain.dto'
import { DomainService } from '@halo/services/index'
import { Feed } from '@pushly/models/lib/structs/feeds/feed'

interface ILoadableDataState<T> {
    data?: {
        feed: T
        meta: any
    }
    loading: boolean
}
export type LoadableDataState<T> = ILoadableDataState<T>

export const FeedPage = (props: any) => {
    const domainSvc: DomainService = Container.get(DomainService)
    const feedSvc: FeedService = Container.get(FeedService)

    const domainId = parseInt(props.match.params.domainId, 10)
    const feedId = props.match.params.feedId

    // ----------------------------------  Stateful Variables  ---------------------------------- //
    const [domain, setDomain] = useState<DomainDto>()
    const [feed, setFeed] = useLoadableDataState<{ feed: Feed | any; meta: any }>({ data: { feed: {}, meta: {} } })

    // ---------------------------------- Rendering Functions ---------------------------------- //
    async function fetchDomain() {
        const { data } = await domainSvc.fetchById(domainId)

        setDomain(data)
    }
    async function fetchFeed() {
        setFeed((state) => ({ ...state, loading: true }))
        const { data: feedResponse, meta } = await feedSvc.fetchFeedById(domainId, feedId)

        setFeed({ loading: false, data: { feed: feedResponse, meta } })
    }

    React.useEffect(() => {
        fetchDomain()
        fetchFeed()
    }, [feedId, domainId])

    function render() {
        return (
            <div className={classnames('feed-details-page')}>
                <FeedPageHeader domainName={domain?.display_name} feed={feed} />

                {feed.data?.feed.id && <FeedDetailsWell feed={feed} domainId={domainId} />}
            </div>
        )
    }

    return render()
}
